<script>
  import PopupWindow from '../components/container/popup/popup-window/index.vue'

  export default {
    name: 'page-render',
    props: {
      node: Object
    },
    render (h) {
      return (
        <page node={this.node}>
          <popup-window>
            <render viewContent={this.node.viewContent}/>
          </popup-window>
        </page>
      )
    },
    components: {PopupWindow}
  }
</script>
